import React from 'react'
import { Card, colors, H2, Separator, Skeleton } from '@fs/zion-ui'
import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFileFailed, type GedcomFile } from '../../../services/groupTypes'
import ManageTreeList, { ManageTreeListSkeleton } from './ManageTreeList'
import UploadTreeButton from './UploadTreeButton'

type Props = {
  groupTitle: string
  groups: GroupSummary[]
  isMobile: boolean
  processingFiles?: GedcomFile[]
  failedFiles?: GedcomFileFailed[]
  showUploadButton?: boolean
}

function ManageTreeGroup({
  groupTitle,
  groups,
  isMobile,
  processingFiles,
  failedFiles,
  showUploadButton,
}: Props): JSX.Element {
  return (
    <Card margins="xs" edges="border" backgroundColor={colors.gray00}>
      <H2 size="H5">{groupTitle}</H2>
      <Separator size="xs" />
      {/* This card is only rendered by the pre-combined design, so its list never takes the table shape. */}
      <ManageTreeList
        processingFiles={processingFiles}
        groups={groups}
        failedFiles={failedFiles}
        isMobile={isMobile}
        showCombinedDesign={false}
      />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      {showUploadButton && <UploadTreeButton emphasis="medium" />}
    </Card>
  )
}

export default ManageTreeGroup

export function ManageTreeGroupSkeleton({ isMobile }: { isMobile: boolean }): JSX.Element {
  return (
    <Card margins="xs">
      <Skeleton.H5 />
      <Separator size="xs" />
      <ManageTreeListSkeleton isMobile={isMobile} />
    </Card>
  )
}
